import { useState } from "react";

export interface PromptState {
  title: string;
  text: string;
  variant?: "success" | "error" | "warning";
}

export function usePurchasesModals() {
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [editModalId, setEditModalId] = useState<number | null>(null);
  const [detailModal, setDetailModal] = useState<number | null>(null);
  const [quickViewModalId, setQuickViewModalId] = useState<number | null>(null);
  const [confirmDelete, setConfirmDelete] = useState<string | null>(null);
  const [confirmApprove, setConfirmApprove] = useState<string | null>(null);
  const [confirmMarkPaid, setConfirmMarkPaid] = useState<string | null>(null);
  const [prompt, setPrompt] = useState<PromptState | null>(null);

  return {
    createModal,
    setCreateModal,
    editModalId,
    setEditModalId,
    detailModal,
    setDetailModal,
    quickViewModalId,
    setQuickViewModalId,
    confirmDelete,
    setConfirmDelete,
    confirmApprove,
    setConfirmApprove,
    confirmMarkPaid,
    setConfirmMarkPaid,
    prompt,
    setPrompt,
  };
}
